import React, { useState } from 'react';
import cx from 'classnames';
import FacebookLogin, { ReactFacebookLoginInfo } from 'react-facebook-login';
import {
  LoginResult,
  sendFacebookLoginRequest,
  ErrorType,
} from '@zola-helpers/client/dist/es/redux/auth/authActions';

import { HostName } from '../../types';
import useGuessTimezone from '../../../../hooks/useGuessTimezone';

import styles from './FacebookLoginButton.module.less';

type FacebookLoginButtonProps = {
  buttonText?: string;
  callback: (data: LoginResult, email?: string) => void;
  errorCallback: (response: ErrorType) => void;
};

const FacebookLoginButton: React.FC<FacebookLoginButtonProps> = ({
  buttonText = 'Sign Up With Facebook',
  callback,
  errorCallback,
}) => {
  const [timezone] = useGuessTimezone();
  const [appId] = useState(() => {
    const hostname = window?.location?.hostname.toLowerCase();
    switch (hostname) {
      case HostName.LOCALHOST:
        return '203261903194460';
      case HostName.QA:
      case HostName.QA_HOMESTORE:
        return '1440191932862526';
      case HostName.PROD:
      default:
        return '215495315286955';
    }
  });

  const fbCallback = (fbLoginResponse: ReactFacebookLoginInfo) => {
    const facebookId = fbLoginResponse.userID;
    const requestData = {
      facebook_id: facebookId,
      short_term_access_token: fbLoginResponse.accessToken,
      timezone,
    };

    if (facebookId) {
      sendFacebookLoginRequest(requestData).then(callback).catch(errorCallback);
    }
  };

  return (
    <FacebookLogin
      appId={appId}
      autoLoad={false}
      scope="public_profile,email"
      textButton={buttonText}
      cssClass={cx('v2-button primary-button button--fullWidth button-facebook', styles.button)}
      icon={<i className="zola-ui-icon-facebook hidden-xs" />}
      isMobile={false}
      callback={fbCallback}
    />
  );
};

export default FacebookLoginButton;
